import { Field, NumericInput, TextInput, TextOutput } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { WorksheetBalanceFieldSet } from '../../../../Core/WorksheetEquipment';

const WashingSectionContent = () => (
  <>
    <Field
      input={<WorksheetEquipmentDropdown />}
      label="Guard sieve"
      equipmentType="sieve"
      name="Equipment.GuardSieve"
      queryParams={{ SieveSize: '1.18 mm' }}
    />
    <Field
      input={<WorksheetEquipmentDropdown />}
      label="Washing sieve"
      equipmentType="sieve"
      name="Equipment.WashingSieve"
      queryParams={{ SieveSize: '75.0 μm' }}
    />
    <WorksheetBalanceFieldSet label="Balance" name="Equipment.WashedBalance" />
    <Field input={<WorksheetEquipmentDropdown />} label="Oven" equipmentType="oven" name="Equipment.WashedOven" />
    <Field input={<TextInput />} label="Tare ID" name="Masses.WashedPortionTareID" />
    <Field input={<NumericInput />} label="Tare and Washed Portion Dry Mass" name="Masses.WashedTareAndDryMass" />
    <Field input={<TextOutput />} label="Washed Portion Dry Mass" name="Masses.WashedDryMass" />
    <Field input={<TextOutput />} label="Mass of Washings" name="Masses.WashingsDryMass" />
  </>
);

const WashingSection = () => (
  <ListFieldSection heading="Washing">
    <WashingSectionContent />
  </ListFieldSection>
);

export { WashingSection, WashingSectionContent };
